import { createRouter, createWebHashHistory, type RouteRecordRaw } from "vue-router";
import OrderTopBar from "@/views/order/partials/TopBar.vue";
import DigitalMenuOrder from "@/views/order/DigitalMenuOrder.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: { name: "order" }
  },
  {
    path: "/order",
    name: "order",
    components: {
      topBar: OrderTopBar,
      default: DigitalMenuOrder
    },
    meta: { mainView: true, hideNavbar: true }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: "order" }
  }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes
});

export default router;